import { useEffect, useRef, useState } from "react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../../../../../shared/components/card/Card";
import RangeDatePicker from "../../../../../shared/components/datepicker/RangeDatePicker";
import { MultiSelect } from "../../../../../shared/components/select/MultiSelect";
import { useTranslation } from "react-i18next";
import SearchInput from "../../../../../shared/components/input/SearchInput";

const TacticLinesPerformanceFilters = ({
  selectables,
  defaultDateValue,
  onDateChangeValue,
  onStrategyChangeValue,
  onChannelChangeValue,
  onPlatformChangeValue,
  onClientChangeValue,
  onCampaignChangeValue,
  onMarketChangeValue,
  onCategoryChangeValue,
  onProductChangeValue,
  onTacticLinesNameChangeValue,
  onCurrentStatusChangeValue,
}) => {
  const { t } = useTranslation();
  const [isDisabled, setIsDisabled] = useState(true);
  const clientsRef = useRef();

  const [campaigns, setCampaigns] = useState([]);
  const [markets, setMarkets] = useState([]);
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);

  const onClientChangeValueHandler = (client) => {
    if (client.length > 0) {
      updateDependantStates(setCampaigns, client, (value) => value.campaigns);
      updateDependantStates(setMarkets, client, (value) => value.markets);
      updateDependantStates(setCategories, client, (value) => value.categories);
      updateDependantStates(setProducts, client, (value) => value.products);
      setIsDisabled(false);
    } else {
      setCampaigns([]);
      setMarkets([]);
      setCategories([]);
      setProducts([]);
      setIsDisabled(true);
    }
    onClientChangeValue(client);
  };

  const updateDependantStates = (setStateFunction, clients, mapFunction) => {
    setStateFunction(
      clientsRef.current
        .filter((value) => clients.includes(value.client.value))
        .map(mapFunction)
        .flat(),
    );
  };

  useEffect(() => {
    clientsRef.current = selectables?.clients;
  }, [selectables]);

  return (
    <Card className="w-full">
      <CardHeader>
        <div className="flex flex-row w-full">
          <div className="w-1/2">
            <CardTitle>{t("tacticLinesEfficiency.header.title")}</CardTitle>
            <CardDescription>
              {t("tacticLinesEfficiency.header.subtitle")}
            </CardDescription>
          </div>
          <div className="flex flex-row-reverse w-1/2">
            <SearchInput
              onChangeHandler={onTacticLinesNameChangeValue}
              placeholder={t(
                "tacticLinesEfficiency.header.searchInputPlaceholder",
              )}
            />
          </div>
        </div>
      </CardHeader>
      <CardContent>
        <div className="flex flex-row">
          <RangeDatePicker
            onValueChange={onDateChangeValue}
            defaultValue={defaultDateValue}
          />
          <div className="w-full">
            <div className="grid grid-cols-3 gap-x-2">
              <MultiSelect
                placeholder="Elegir clientes"
                options={selectables?.clients.map((client) => client.client)}
                onValueChange={onClientChangeValueHandler}
              />
              <MultiSelect
                placeholder={
                  isDisabled
                    ? "Elija cliente para activar campañas"
                    : "Elegir campañas"
                }
                options={campaigns}
                onValueChange={onCampaignChangeValue}
                isDisabled={isDisabled}
              />
              <MultiSelect
                placeholder="Elegir plataformas"
                options={selectables?.platforms}
                onValueChange={onPlatformChangeValue}
              />
            </div>
            <div className="grid grid-cols-3 gap-x-2">
              <MultiSelect
                placeholder="Elegir estrategias"
                options={selectables?.strategies}
                onValueChange={onStrategyChangeValue}
              />
              <MultiSelect
                placeholder={
                  isDisabled
                    ? "Elija cliente para activar categorías"
                    : "Elegir categorías"
                }
                options={categories}
                onValueChange={onCategoryChangeValue}
                isDisabled={isDisabled}
              />
              <MultiSelect
                placeholder={
                  isDisabled
                    ? "Elija cliente para activar productos"
                    : "Elegir productos"
                }
                options={products}
                onValueChange={onProductChangeValue}
                isDisabled={isDisabled}
              />
            </div>
            <div className="grid grid-cols-3 gap-x-2">
              <MultiSelect
                placeholder={
                  isDisabled
                    ? "Elija cliente para activar mercados"
                    : "Elegir mercados"
                }
                options={markets}
                onValueChange={onMarketChangeValue}
                isDisabled={isDisabled}
              />
              <MultiSelect
                placeholder="Elegir canales"
                options={selectables?.channels}
                onValueChange={onChannelChangeValue}
              />
              <MultiSelect
                placeholder="Elegir current status"
                options={selectables?.currentStatuses}
                onValueChange={onCurrentStatusChangeValue}
              />
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default TacticLinesPerformanceFilters;
